export default {
  data () {
    return {
      schoolIndex: 1,
      productIndex: 1,
      aptitudeIndex: 1,
      timer: null
    }
  },
  created () {
    this.timer = setInterval(this.identificationAnimate, 3000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    schoolLeft () {
      if (this.schoolIndex === 1) {
        this.$refs.listWrap.style.transition = 'none'
        this.schoolIndex = 3
        setTimeout(() => {
          this.$refs.listWrap.style.transition = 'margin-left 1s'
          this.schoolIndex = 2
        }, 50)
        return
      }
      this.schoolIndex--
    },
    schoolRight () {
      if (this.schoolIndex === 3) {
        this.$refs.listWrap.style.transition = 'none'
        this.schoolIndex = 1
        setTimeout(() => {
          this.$refs.listWrap.style.transition = 'margin-left 1s'
          this.schoolIndex = 2
        }, 50)
        return
      }
      this.schoolIndex++
    },
    productLeft () {
      this.productIndex > 1 && this.productIndex--
    },
    productRight () {
      this.productIndex < 7 && this.productIndex++
    },
    identificationAnimate () {
      let { aptitudeIndex } = this
      aptitudeIndex++
      if (aptitudeIndex >= 8) {
        aptitudeIndex = 1
      }
      this.aptitudeIndex = aptitudeIndex
    }
  }
}
